export type TileSelectGroupLayout = "vertical" | "horizontal";
